import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Table,
  Badge,
  Spinner,
  Row,
  Col,
  Input,
  Button,
} from "reactstrap";
import { getFeesListApi } from "../../api/apiUrlConst";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const FeesCollection = () => {
  const [feesList, setFeesList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filteredList, setFilteredList] = useState<any[]>([]);
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const data = await getFeesListApi();
      setFeesList(data);
      setFilteredList(data);
    } catch {
      toast.error("Failed to load fees list");
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  let data = [...feesList];

  // 🔍 Search filter
  if (search) {
    const searchLower = search.toLowerCase();

    data = data.filter((f) =>
      f.enqFormId?.toString().toLowerCase().includes(searchLower) ||
      f.totalFees?.toString().includes(searchLower) ||
      f.paidAmount?.toString().includes(searchLower) ||
      f.pendingAmount?.toString().includes(searchLower)
    );
  }

  const today = new Date();
  today.setHours(0,0,0,0);

  // 🎯 Status filter
 if (statusFilter) {
  data = data.filter((f) => {

    const isOverdue =
      f.nextDueDate &&
      new Date(f.nextDueDate) < new Date() &&
      f.pendingAmount > 0;

    const status = f.isFullyPaid
      ? "FullyPaid"
      : isOverdue
      ? "Overdue"
      : "Pending";

    return status === statusFilter;
  });
}

  // ⭐ Sort by Closest Next Due Date
  data.sort((a, b) => {
    const dateA = a.nextDueDate ? new Date(a.nextDueDate).getTime() : Infinity;
    const dateB = b.nextDueDate ? new Date(b.nextDueDate).getTime() : Infinity;
    return dateA - dateB;
  });

  setFilteredList(data);

}, [search, statusFilter, feesList]);

  const getStatusBadge = (fee: any) => {
    const today = new Date();
    const dueDate = fee.nextDueDate
      ? new Date(fee.nextDueDate)
      : null;

    if (fee.pendingAmount === 0) {
      return <Badge color="success">Paid</Badge>;
    }

    if (dueDate && dueDate < today) {
      return <Badge color="danger">Overdue</Badge>;
    }

    return <Badge color="warning">Pending</Badge>;
  };

  const ClearFilter = () => {
    setSearch("");
    setStatusFilter("");
  };

  if (loading)
    return (
      <div className="text-center mt-5">
        <Spinner color="primary" />
      </div>
    );

  return (
    <div
      className="p-4"
      style={{ background: "#f4f6fb", minHeight: "100vh" }}
    >
      {/* ===== HEADER ===== */}
      <div
        className="p-4 mb-4"
        style={{
          background: "linear-gradient(90deg, #374151, #093d92)",
          borderRadius: "16px",
          color: "#fff",
        }}
      >
        {/* Title Section */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">

          {/* Left Side */}
          <div>
            <h3 className="fw-bold mb-1">Fees Collection</h3>
            <small>Track payments and pending balances</small>
          </div>

          {/* Right Side Filters */}
          <div className="d-flex gap-3 mt-3 mt-md-0">

            <Input
              placeholder="🔍 Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="rounded-pill shadow-sm"
              style={{ width: "250px" }}
            />

            <Input
              type="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="rounded-pill shadow-sm"
              style={{ width: "180px" }}
            >
              <option value="">All Status</option>
              <option value="FullyPaid">Fully Paid</option>
              <option value="Pending">Pending</option>
              <option value="Overdue">Overdue</option>
            </Input>
            <Button
            color="primary"
            onClick={ClearFilter}
            >Clear</Button>

          </div>
        </div>
      </div>

      {/* ===== TABLE CARD ===== */}
      <Card
        className="border-0 shadow-sm"
        style={{ borderRadius: "16px" }}
      >
        <CardBody>
          <Table
            responsive
            hover
            className="align-middle"
            style={{
              borderCollapse: "separate",
              borderSpacing: "0 8px",
            }}
          >
            <thead>
              <tr style={{ background: "#eef2f7" }}>
                <th>Enquiry ID</th>
                <th>Name</th>
                <th>Course</th>
                <th>Phone No</th>
                <th>Account</th>
                <th>Total Payment</th>
                <th>Pending Amount</th>
                <th>Next Due</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredList.length === 0 && (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center text-muted"
                  >
                    No fees records found
                  </td>
                </tr>
              )}

              {filteredList.map((f) => {
                const isOverdue =
                  f.nextDueDate &&
                  new Date(f.nextDueDate) < new Date() &&
                  f.pendingAmount > 0;

                return (
                  <tr
                    key={f.id}
                    style={{
                      background: "#fff",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
                      cursor: "pointer",
                    }}
                  //   onClick={() =>
                  //     navigate(`/coordinator/enquiries/${f.enqFormId}`)
                  //}
                  >
                    <td className="fw-bold text-primary">
                      {f.eid}
                    </td>

                    <td>{f.name}</td>

                    <td>
                        {f.course}
                    </td>
                    <td>
                        {f.phoneNo}
                    </td>
                    <td >
  {f.payments?.[0]?.account}
</td>

                    <td className="fw-semibold text-success">
                      ₹ {f.totalFees?.toLocaleString()}
                    </td>

                    <td className="fw-semibold text-danger">
                      ₹ {f.pendingAmount?.toLocaleString()}
                    </td>

                    {/* Next Due */}
                    <td
                      className={
                        isOverdue ? "fw-bold text-danger" : ""
                      }
                    >
                      {f.nextDueDate
                        ? new Date(
                          f.nextDueDate
                        ).toLocaleDateString()
                        : "-"}
                    </td>

                    <td>{getStatusBadge(f)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

export default FeesCollection;